import {createEffect} from "effector";

export const sendRegistrationFx = createEffect().use(async (payload) => {
	try {
		const response = await fetch(
			'https://ste1h7g7s7.execute-api.eu-west-1.amazonaws.com/LoyaltySystem1/UserRecords',
			{
				method: 'POST',
				body: JSON.stringify(payload)
			}
		)

		return await response.json()
	} catch (e) {
		console.error(e)
	}
})
